const CookieEssentialIcon = ({ width = 18, height = 18, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(4 8)"
      d="M8 0H2C0.89543 0 0 0.89543 0 2V5C0 6.10457 0.89543 7 2 7H8C9.10457 7 10 6.10457 10 5V2C10 0.89543 9.10457 0 8 0Z"
      fill="currentColor"
    />
    <path
      transform="translate(5.25 2.25)"
      d="M0.75 5.75V3.75C0.75 2.95435 1.06607 2.19129 1.62868 1.62868C2.19129 1.06607 2.95435 0.75 3.75 0.75C4.54565 0.75 5.30871 1.06607 5.87132 1.62868C6.43393 2.19129 6.75 2.95435 6.75 3.75V5.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      transform="translate(7.7994 10.2996)"
      d="M1.2 2.4C1.86274 2.4 2.4 1.86274 2.4 1.2C2.4 0.537258 1.86274 0 1.2 0C0.537258 0 0 0.537258 0 1.2C0 1.86274 0.537258 2.4 1.2 2.4Z"
      fill="white"
    />
  </svg>
);

export default CookieEssentialIcon;
